import { api } from "@/api/client";

export const TIPO_ARQUIVO_PATH = "instituicao/TipoArquivo";

export interface TipoArquivo {
  id: number;
  descricao: string;
}

export interface TipoArquivoFiltro {
  descricao?: string;
}

export async function getTipoArquivo(id: number): Promise<TipoArquivo> {
  const { data } = await api.get<TipoArquivo>(`${TIPO_ARQUIVO_PATH}/${id}`);
  return data;
}

// Legado sempre usa POST tanto pra criar quanto pra editar (o backend decide
// pelo id no corpo) — ver app/controllers/consulta-tipo-arquivo.controller.js.
export async function saveTipoArquivo(registro: Partial<TipoArquivo>): Promise<TipoArquivo> {
  const { data } = await api.post<TipoArquivo>(TIPO_ARQUIVO_PATH, registro);
  return data;
}
